// ------------------------------------------------------------------------------
// <auto-generated>
// This code was generated by the @augloop/code-gen tool.
// Source: https://dev.azure.com/office/ISS/_git/augloop-server?path=%2Fmodules%2Finterfaces%2Fsrc%2Fiasync-boundary-loader.ts
// Changes to this file may cause incorrect behavior and will be lost upon regeneration.
// </auto-generated>
// ------------------------------------------------------------------------------
import { AsyncBoundaryLoaderKind, AsyncBoundaryLoaderType } from '../../iasync-boundary-loader';
import { AsyncBoundaryRequest, FilteringAsyncBoundaryRequest, ModelIteratingAsyncBoundaryRequest } from '../iasync-boundary-loader.g';
import { itemFilterValidatorInstance, itemWithPathValidatorInstance, schemaObjectHeaderValidatorInstance } from '@augloop/types-core';
import { validateArray } from '@augloop/validator-common';
export class AsyncBoundaryRequestValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'AsyncBoundaryRequest: Expected object, got undefined object for AsyncBoundaryRequestValidator' };
        }
        if (obj.rootItemPath === undefined) {
            return { success: false, error: 'AsyncBoundaryRequest: Required field "rootItemPath" is missing' };
        }
        else {
            const result = validateArray(obj.rootItemPath, 1, undefined, 'string');
            if (!result.success) {
                result.error = "AsyncBoundaryRequest.rootItemPath: " + result.error;
                return result;
            }
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!AsyncBoundaryRequest.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "AsyncBoundaryRequest"' };
        }
        return { success: true };
    }
}
export const asyncBoundaryRequestValidatorInstance = new AsyncBoundaryRequestValidator();
export class FilteringAsyncBoundaryRequestValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'FilteringAsyncBoundaryRequest: Expected object, got undefined object for FilteringAsyncBoundaryRequestValidator' };
        }
        if (obj.filter === undefined) {
            return { success: false, error: 'FilteringAsyncBoundaryRequest: Required field "filter" is missing' };
        }
        else {
            const result = itemFilterValidatorInstance.validate(obj.filter);
            if (!result.success) {
                result.error = "FilteringAsyncBoundaryRequest.filter: " + result.error;
                return result;
            }
        }
        if (obj.rootItemPath === undefined) {
            return { success: false, error: 'FilteringAsyncBoundaryRequest: Required field "rootItemPath" is missing' };
        }
        else {
            const result = validateArray(obj.rootItemPath, 1, undefined, 'string');
            if (!result.success) {
                result.error = "FilteringAsyncBoundaryRequest.rootItemPath: " + result.error;
                return result;
            }
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!FilteringAsyncBoundaryRequest.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "FilteringAsyncBoundaryRequest"' };
        }
        return { success: true };
    }
}
export const filteringAsyncBoundaryRequestValidatorInstance = new FilteringAsyncBoundaryRequestValidator();
export class ModelIteratingAsyncBoundaryRequestValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'ModelIteratingAsyncBoundaryRequest: Expected object, got undefined object for ModelIteratingAsyncBoundaryRequestValidator' };
        }
        if (obj.pageSize === undefined) {
            return { success: false, error: 'ModelIteratingAsyncBoundaryRequest: Required field "pageSize" is missing' };
        }
        else if (typeof obj.pageSize !== 'number') {
            return { success: false, error: 'ModelIteratingAsyncBoundaryRequest: Required field "pageSize" is wrong type' };
        }
        if ((obj.lastItemPathKey !== undefined) && (typeof obj.lastItemPathKey !== 'string')) {
            return { success: false, error: 'ModelIteratingAsyncBoundaryRequest: Optional field "lastItemPathKey" is wrong type' };
        }
        if (obj.rootItemPath === undefined) {
            return { success: false, error: 'ModelIteratingAsyncBoundaryRequest: Required field "rootItemPath" is missing' };
        }
        else {
            const result = validateArray(obj.rootItemPath, 1, undefined, 'string');
            if (!result.success) {
                result.error = "ModelIteratingAsyncBoundaryRequest.rootItemPath: " + result.error;
                return result;
            }
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!ModelIteratingAsyncBoundaryRequest.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "ModelIteratingAsyncBoundaryRequest"' };
        }
        return { success: true };
    }
}
export const modelIteratingAsyncBoundaryRequestValidatorInstance = new ModelIteratingAsyncBoundaryRequestValidator();
export class ModelIteratingAsyncBoundaryResponseValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'ModelIteratingAsyncBoundaryResponse: Expected object, got undefined object for ModelIteratingAsyncBoundaryResponseValidator' };
        }
        if ((obj.lastItemPathKey !== undefined) && (typeof obj.lastItemPathKey !== 'string')) {
            return { success: false, error: 'ModelIteratingAsyncBoundaryResponse: Optional field "lastItemPathKey" is wrong type' };
        }
        if (obj.items === undefined) {
            return { success: false, error: 'ModelIteratingAsyncBoundaryResponse: Required field "items" is missing' };
        }
        else {
            const result = validateArray(obj.items, 1, itemWithPathValidatorInstance, '{ItemWithPath}');
            if (!result.success) {
                result.error = "ModelIteratingAsyncBoundaryResponse.items: " + result.error;
                return result;
            }
        }
        if (obj.existingAnnotations === undefined) {
            return { success: false, error: 'ModelIteratingAsyncBoundaryResponse: Required field "existingAnnotations" is missing' };
        }
        else {
            const result = validateArray(obj.existingAnnotations, 1, itemWithPathValidatorInstance, '{ItemWithPath}');
            if (!result.success) {
                result.error = "ModelIteratingAsyncBoundaryResponse.existingAnnotations: " + result.error;
                return result;
            }
        }
        if (obj.endReached === undefined) {
            return { success: false, error: 'ModelIteratingAsyncBoundaryResponse: Required field "endReached" is missing' };
        }
        else if (typeof obj.endReached !== 'boolean') {
            return { success: false, error: 'ModelIteratingAsyncBoundaryResponse: Required field "endReached" is wrong type' };
        }
        return { success: true };
    }
}
export const modelIteratingAsyncBoundaryResponseValidatorInstance = new ModelIteratingAsyncBoundaryResponseValidator();
export class AsyncBoundaryLoaderValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'AsyncBoundaryLoader: Expected object, got undefined object for AsyncBoundaryLoaderValidator' };
        }
        if (obj.kind === undefined) {
            return { success: false, error: 'AsyncBoundaryLoader: Required field "kind" is missing' };
        }
        else {
            const result = asyncBoundaryLoaderKindValidatorInstance.validate(obj.kind);
            if (!result.success) {
                result.error = "AsyncBoundaryLoader.kind: " + result.error;
                return result;
            }
        }
        return { success: true };
    }
}
export const asyncBoundaryLoaderValidatorInstance = new AsyncBoundaryLoaderValidator();
export class ModelIteratingAsyncBoundaryLoaderValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'ModelIteratingAsyncBoundaryLoader: Expected object, got undefined object for ModelIteratingAsyncBoundaryLoaderValidator' };
        }
        if (obj.kind === undefined) {
            return { success: false, error: 'ModelIteratingAsyncBoundaryLoader: Required field "kind" is missing' };
        }
        else {
            const result = asyncBoundaryLoaderKindValidatorInstance.validate(obj.kind);
            if (!result.success) {
                result.error = "ModelIteratingAsyncBoundaryLoader.kind: " + result.error;
                return result;
            }
        }
        return { success: true };
    }
}
export const modelIteratingAsyncBoundaryLoaderValidatorInstance = new ModelIteratingAsyncBoundaryLoaderValidator();
export class FilteringAsyncBoundaryLoaderValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'FilteringAsyncBoundaryLoader: Expected object, got undefined object for FilteringAsyncBoundaryLoaderValidator' };
        }
        if (obj.kind === undefined) {
            return { success: false, error: 'FilteringAsyncBoundaryLoader: Required field "kind" is missing' };
        }
        else {
            const result = asyncBoundaryLoaderKindValidatorInstance.validate(obj.kind);
            if (!result.success) {
                result.error = "FilteringAsyncBoundaryLoader.kind: " + result.error;
                return result;
            }
        }
        return { success: true };
    }
}
export const filteringAsyncBoundaryLoaderValidatorInstance = new FilteringAsyncBoundaryLoaderValidator();
export class AsyncBoundaryLoaderTypeValidator {
    validate(value) {
        if (!AsyncBoundaryLoaderTypeValidator.validValues.has(value)) {
            return { success: false, error: 'Invalid value for enum "AsyncBoundaryLoaderType"' };
        }
        return { success: true };
    }
}
AsyncBoundaryLoaderTypeValidator.validValues = new Set([AsyncBoundaryLoaderType.MastermindAsyncBoundaryLoader, AsyncBoundaryLoaderType.TruncatedModelIteratingLoader, AsyncBoundaryLoaderType.ExcelAsyncBoundaryLoader]);
export const asyncBoundaryLoaderTypeValidatorInstance = new AsyncBoundaryLoaderTypeValidator();
export class AsyncBoundaryLoaderKindValidator {
    validate(value) {
        if (!AsyncBoundaryLoaderKindValidator.validValues.has(value)) {
            return { success: false, error: 'Invalid value for enum "AsyncBoundaryLoaderKind"' };
        }
        return { success: true };
    }
}
AsyncBoundaryLoaderKindValidator.validValues = new Set([AsyncBoundaryLoaderKind.Filtering, AsyncBoundaryLoaderKind.ModelIterating]);
export const asyncBoundaryLoaderKindValidatorInstance = new AsyncBoundaryLoaderKindValidator();
//# sourceMappingURL=iasync-boundary-loader-validator.g.js.map